import React, {useMemo} from 'react';
import PropTypes from 'prop-types';
import {useComponentProps} from 'helpers/hooks/utils';
import utils from 'helpers/utils';
import {useTable} from 'components/organisms/Providers/TableProvider/TableProvider';
import StyledCollectionEntitiesTableBar
  from 'components/organisms/Bars/CollectionEntitiesTableBar/CollectionEntitiesTableBar.styles';
import {useSplitPath} from 'helpers/hooks/links';
import constants from 'helpers/constants';
import useMediaQuery from '@mui/material/useMediaQuery';

const CollectionEntitiesTableBar = React.forwardRef((props, ref) => {
  const innerProps = useComponentProps(props, 'CollectionEntitiesTableBar');

  const tableProvider = useTable();
  const collection = tableProvider.context?.data;
  const [, pathPostfix] = useSplitPath('entities');

  const smDown = useMediaQuery((theme) => theme.breakpoints.down('sm'));

  const isSuggestion = Boolean(tableProvider?.view?.activeViews?.find((v) => v.name === 'suggestions'));
  const isRejection = Boolean(tableProvider?.view?.activeViews?.find((v) => v.name === 'rejections'));
  const entitiesCount = collection?.newInCollection?.[constants.collection.scopes.inside]?.total ??
    tableProvider.list?.meta?.resultsCount;

  const assistantAction = useMemo(() => ({
    auth: utils.createAuth({ attribute: 'collection.entity.assistant', meta: {collection: collection} }),
    ActionButtonProps: {
      color: 'primary',
      variant: 'contained'
    },
    ActionIconButtonProps: {
      color: 'primary',
      variant: 'contained'
    }
  }), [collection]);

  const filterAction = useMemo(() => ({
    auth: utils.createAuth({ attribute: 'collection.entity.filters', meta: {collection: collection} }),
  }), [collection]);

  const columnAction = useMemo(() => ({
    auth: (!(isSuggestion || isRejection) && entitiesCount === 0) ? utils.createAuth({attribute: 'system.null'}) :
      utils.createAuth({ attribute: 'collection.entity.columns', meta: {collection: collection} }),
  }), [collection, isSuggestion, isRejection, entitiesCount]);

  innerProps.className = utils.flattenClassName(innerProps.className);

  return <StyledCollectionEntitiesTableBar ref={ref} {...innerProps}
                                           hideColumn={Boolean(pathPostfix) || smDown}
                                           assistantAction={assistantAction}
                                           filterAction={filterAction}
                                           columnAction={columnAction} />
});

CollectionEntitiesTableBar.propTypes = {
  className: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.func
  ])
};

export default CollectionEntitiesTableBar;
